import clsx from "clsx";
import { FC } from "react";

interface Props {
  className?: string;
}

const Divider: FC<Props> = ({ className }) => {
  return (
    <div
      className={clsx("h-1 w-full border-t border-slate-200", className)}
    ></div>
  );
};

export default Divider;
